module.exports = __webpack_public_path__ + "static/media/intro.368607e2.mp3";